import Router from "../router";
import { HTTP } from "./HttpServices";
import StoreManagement from "./StoreManagement";
import store from "../store"

export default {
  isLoggedIn() {
    return !!StoreManagement.getToken() && !!StoreManagement.getUser();
  },
  login(user) {
    return new Promise((resolve, reject) => {
      HTTP.post("login", user).then(
        resp => {
          // stores token
          StoreManagement.setToken(resp.headers.authorization);

          store.dispatch("getUserInfo").then(user => {
            // stores user

            if(user.password){
              delete user.password;
            }
            StoreManagement.setUser(user);
            resolve(resp);
          });

        },
        error => {
          reject(error);
        }
      );
    });
  },
  logout() {
    StoreManagement.deleteToken();
    StoreManagement.deleteUser();
    Router.push({ name: "login" });
  }
};
